export default {
  setErrors: (state, error) => {
    state.errors = { ...state.errors, ...error };
  },
  setSubscription: (state, response) => {
    state.subscriptionInfo = response;
  },
  setUnsubscribe: (state, response) => {
    state.unsubscribeInfo = response;
  },
  setCreateSubscriptionResponse: (state, response) => {
    state.createSubscription = response;
  },
  setServiceCatalogs: (state, catalogs) => {
    state.serviceCatalogs = catalogs;
  },
  resetCreatedSubscription: state => {
    state.createSubscription = null;
  }
};
